import React from "react";
import { Button, Modal, Table, Form } from '@themesberg/react-bootstrap';
import { useCookies } from "react-cookie";
import { updateClassicInputTicket } from "../../../../controller/api/__classic__/ticketStorage";
import ImageUpload from './add-ticket-popup/component/ImageUpload';
import ImagePreview from '../../ticket/sub-screen/image-preview/ImagePreview';

export default (props) => {
  const { show, onHide, ticketData, cookies, resultId, onRefresh } = props;

  const [numbers, setNumbers] = React.useState('');
  const [amount, setAmount] = React.useState('');
  const [images, setImages] = React.useState('');
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [showImagePreview, setShowImagePreview] = React.useState(false);

  React.useEffect(() => {
    if (ticketData) {
      setNumbers(ticketData.numbers || '');
      setAmount(ticketData.inputAmount || '');
      setImages(ticketData.images || '');
    }
  }, [ticketData]);

  const expectedDigits = React.useMemo(() => {
    const len = (ticketData?.numbers || '').length;
    return len === 5 ? 5 : 6;
  }, [ticketData]);

  const _onHide = () => {
    setNumbers('');
    setAmount('');
    setImages('');
    onHide();
  }

  const onSubmit = async () => {
    if (numbers.length !== expectedDigits) {
      alert(`Dãy số phải có đúng ${expectedDigits} số`);
      return;
    }
    if (amount === '' || isNaN(amount) || parseInt(amount) <= 0) {
      alert('Số lượng phải lớn hơn 0');
      return;
    }
    
    setIsSubmitting(true);
    try {
      const resp = await updateClassicInputTicket(cookies.lottmekong, ticketData.id, numbers, parseInt(amount), ticketData.isSingle, images);
      if (resp) {
        alert('Cập nhật thành công');
        if (onRefresh) onRefresh();
        onHide();
      } else {
        alert('Có lỗi xảy ra');
      }
    } catch (error) {
      alert('Lỗi: ' + error.message);
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <Modal
      show={show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      onHide={_onHide}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Chỉnh sửa vé - Dãy số {ticketData?.numbers}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={(e) => e.preventDefault()}>
          <Form.Group className="mb-3">
            <Form.Label>Dãy số ({expectedDigits} số)</Form.Label>
            <Form.Control 
              type="text"
              value={numbers}
              onChange={(e) => setNumbers(e.target.value)}
              placeholder={`Nhập ${expectedDigits} số`}
              maxLength={expectedDigits}
              onInput={(e) => {
                e.target.value = e.target.value.replace(/\D/g, '').slice(0, expectedDigits);
              }}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Số lượng</Form.Label>
            <Form.Control 
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="Nhập số lượng"
              min="1"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Hình ảnh</Form.Label>
            <div>
              {images && (
                <div className="mb-3">
                  <img 
                    src={images && typeof images === 'string' && images.startsWith('http') ? images : `data:image/jpeg;base64,${images}`} 
                    alt="Ticket" 
                    style={{ maxWidth: '200px', maxHeight: '200px', cursor: 'pointer' }}
                    onClick={() => setShowImagePreview(true)}
                  />
                </div>
              )}
              <ImageUpload 
                value={images} 
                onChange={(payload) => setImages(payload)} 
              />
            </div>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={_onHide} disabled={isSubmitting}>Đóng</Button>
        <Button variant="primary" type="button" onClick={onSubmit} disabled={isSubmitting}>
          {isSubmitting ? 'Đang lưu...' : 'Lưu'}
        </Button>
      </Modal.Footer>
      <ImagePreview 
        show={showImagePreview} 
        onHide={() => setShowImagePreview(false)} 
        image={images} 
        title={`Vé số ${numbers}`}
      />
    </Modal>
  );
}
